module.exports = __webpack_public_path__ + "static/media/image-loading.f0c70383.gif";